module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1_5-5a48dee5698632aebd5dcbaeb0b3158b.jpg";